import {
  EstadoFactibilidadCorporativaENUM,
  formatDateWithTimeAMPM, gridSizeMdLg4, ModulosEnumChoice, ROUTER_PATHS, useTableColumnsInventario
} from "@/shared";
import { CustomAutocomplete, CustomTextArea, CustomTextFieldNoForm, SampleTable, SingleTableBoxScene } from "@/shared/components/ui";
import { CategoriaFCorporativaEnum, MaterialTransferido, MotivoRechazo } from "@/shared/interfaces";
import { MaterialesKey, useMaterialesUtilizadosStore } from "@/store/erp";
import { Button, CircularProgress, Grid, Typography } from "@mui/material";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { useEffect, useState } from "react";
import { useUiStore } from "@/store/ui";
import { useFetchPutFactibilidadCorporativo } from "@/shared/actions/erp/factibilidad_corporativo/factibilidad_corporativo.actions";
import { useNavigate } from "react-router-dom";
import { getProductos, useFetchMotivosRechazo } from "@/shared/actions/erp";
import { Refresh } from "@mui/icons-material";
import { MaterialTransferidoInventarioCorporativo } from "@/erp/contabilidad/clientes-corporativos/pages/ClientesCoorporativosSave";
// import { usePlanStore } from "@/store/erp/system-settings/plan.store";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useForm } from "react-hook-form";
import { ModalMotivoForm, newModalMotivoFormaSchema } from "@/shared/utils/validation-schemas/erp/ventas/preventa/preventa_corporativo.schema";
import { yupResolver } from "@hookform/resolvers/yup";
import { IFactibilidadCorporativo } from "@/shared/interfaces/erp/factibilidad_corporativo";
// import { CondicionVentaCorporativa } from "@/shared/interfaces/erp/prospecto/prospecto_corporativo.interface";

interface SaveInventarioSolicitudFactibilidadCorporativoProps {
  dataFactibilidad: IFactibilidadCorporativo
  aprobadoPage: boolean
}

export default function SaveInventarioSolicitudFactibilidadCorporativo({
  dataFactibilidad,
  aprobadoPage
}: SaveInventarioSolicitudFactibilidadCorporativoProps) {

  const { columnsMaterialRevisarFactibilidadCorporativo } = useTableColumnsInventario({
    key: MaterialesKey.ingresoProductos,
  });

  const navigate = useNavigate();
  const [valoresServiciosAdicionalesCorporativos, setValoresServiciosAdicionalesCorporativos] = useState<MaterialTransferidoInventarioCorporativo[]>([]);
  const [valoresPlanesCorporativos, setValoresPlanesCorporativos] = useState<MaterialTransferidoInventarioCorporativo[]>([]);
  const [modalCancelar, setModalCancelar] = useState(false);

  const ingresoProductos = useMaterialesUtilizadosStore(s => s.ingresoProductos);
  // const selectedItems: MaterialTransferidoInventarioCorporativo[] = useMaterialesUtilizadosStore(s => s.selectedItems);
  // const planesCorporativosGlobal = usePlanStore(s => s.plansCorporativos);
  // const addSelectedItem = useMaterialesUtilizadosStore(
  //   s => s.addSelectedItemCustomKey
  // );
  const copyArray = useMaterialesUtilizadosStore(s => s.copyArray);
  const clearSelectedItems = useMaterialesUtilizadosStore(s => s.clearSelectedItems);
  const setConfirmDialog = useUiStore(s => s.setConfirmDialog)
  const setConfirmDialogIsOpen = useUiStore(s => s.setConfirmDialogIsOpen);
  console.log('ingresoProductos', ingresoProductos)

  const {
    mutateAsync: mutateAsyncPutFactibilidadCorporativo
  } = useFetchPutFactibilidadCorporativo({
    enableSuccessAlert: true,
    navigate,
    returnUrl: ROUTER_PATHS.inventario.solicitudFactibilidadCorporativoNav
  })

  const updateFactibilidadCorporativa = useFetchPutFactibilidadCorporativo({
    //navigate: navigate,
    //returnUrl: returnUrl,
  });

  const {
    data: motivosRechazoPaging,
    isLoading: isLoadingMotivosRechazo,
    isRefetching: isRefetchingMotivosRechazo,
  } = useFetchMotivosRechazo(
    {
      estado: true,
      modulo: ModulosEnumChoice.FACTIBILIDAD_CORPORATIVO,
      page_size: 100,
    },
    modalCancelar
  );
  // =============================================================================
  // FORMS
  // =============================================================================
  const formRechazo = useForm<ModalMotivoForm>({
    resolver: yupResolver(newModalMotivoFormaSchema),
  });


  const [isloadingInventaribale, setIsloadingInventaribale] = useState<boolean>(false)

  useEffect(() => {

    if (!isloadingInventaribale) {
      handleObtenerStockActual()
    }

    return () => {
      clearSelectedItems(MaterialesKey.ingresoProductos);
    }

  }, [])

  useEffect(() => {
    clearSelectedItems(MaterialesKey.selectedItems)
    if (!Array.isArray(dataFactibilidad?.detalles))
      return
    // dataFactibilidad?.detalles?.forEach(element => {
    //   const precioUnitarioAux = element.producto_data?.precios?.at(0)?.precio || 0;
    //   //const precioUnitarioAux = element?.producto_data?.precios[0]?.precio || 0;
    //   addSelectedItem(
    //     {
    //       codigo: element.codigo! || element.id!,
    //       nombre: element.nombre! || element.codigo!,
    //       precioUnitario: element.precioUnitario || precioUnitarioAux,
    //       cantidad: element.cantidad!,
    //       total: element.total || element.cantidad! * +precioUnitarioAux,
    //       subtotal: element.subtotal || element.cantidad! * +precioUnitarioAux,
    //       ivaCode: element.ivaCode || "IVA 0%",
    //       ivaValue: element.ivaValue || 0, // 15% de 50
    //       incremento: element.incremento,
    //       incrementoCodigo: element.incrementoCodigo,
    //       precioLibre: element.precioLibre || true,
    //       preciosDisponibles: element.preciosDisponibles || element?.producto_data?.precios,
    //       existe: element.existe,
    //       // incremento:,
    //       categoria_fcorporativa: element.categoria_fcorporativa || CategoriaFCorporativaEnum.MATERIALESEQUIPOS,
    //     },
    //     MaterialesKey.selectedItems, 'codigo', false, false
    //   );
    // });
    // console.log({selectedItems})




    //VALORES DE PLAN
    // const planChoosed = planesCorporativosGlobal.filter(x => x.codigo == dataFactibilidad?.preventa_corporativa_data?.plan)
    // console.log({planChoosed})
    //Se añadenValores de Plan
    if (dataFactibilidad?.plan || dataFactibilidad?.preventa_corporativa_data?.plan) {

      // Si es factibilidad de backup (es_backup=true), los precios de VALORESPLAN deben ser 0
      const esBackup = dataFactibilidad?.es_backup;

      const ValoresPlan: MaterialTransferidoInventarioCorporativo[] = []
      ValoresPlan.push({
        codigo: dataFactibilidad?.preventa_corporativa_data?.plan!,
        nombre: dataFactibilidad?.preventa_corporativa_data?.data_plan_personalizado?.nombre_personalizado || dataFactibilidad?.data_plan_personalizado?.nombre_personalizado || "PLAN DE PRUEBA",
        precioUnitario: esBackup ? 0 : dataFactibilidad?.preventa_corporativa_data?.data_plan_personalizado?.valor_personalizado,
        cantidad: 1,
        total: esBackup ? 0 : (dataFactibilidad?.preventa_corporativa_data?.data_plan_personalizado?.valor_personalizado || dataFactibilidad?.data_plan_personalizado?.valor_personalizado),
        subtotal: esBackup ? 0 : (dataFactibilidad?.preventa_corporativa_data?.data_plan_personalizado?.valor_personalizado || dataFactibilidad?.data_plan_personalizado?.valor_personalizado),
        ivaValue: 0,
        ivaCode: "",
        categoria_fcorporativa: CategoriaFCorporativaEnum.VALORESPLAN,
      })
      ValoresPlan.push({
        codigo: dataFactibilidad?.preventa_corporativa_data?.plan + "-instalacion",
        nombre: "VALOR DE INSTALACIÓN",
        precioUnitario: esBackup ? 0 : (dataFactibilidad.preventa_corporativa_data?.valor_instalacion || dataFactibilidad?.preventa_corporativa_data?.data_plan_personalizado?.costo_instalacion_personalizado),
        cantidad: 1,
        total: esBackup ? 0 : (dataFactibilidad.preventa_corporativa_data?.valor_instalacion || dataFactibilidad?.preventa_corporativa_data?.data_plan_personalizado?.costo_instalacion_personalizado),
        subtotal: esBackup ? 0 : (dataFactibilidad.preventa_corporativa_data?.valor_instalacion || dataFactibilidad?.preventa_corporativa_data?.data_plan_personalizado?.costo_instalacion_personalizado),
        ivaValue: 0,
        ivaCode: "",
        categoria_fcorporativa: CategoriaFCorporativaEnum.VALORESPLAN,
      })
      if (dataFactibilidad?.preventa_corporativa_data?.requiere_backup
        && (
          !!dataFactibilidad?.preventa_corporativa_data?.observaciones?.plan_backup
          || !!dataFactibilidad?.observaciones?.plan_backup
        )
      ) {
        ValoresPlan.push({
          codigo: `${dataFactibilidad?.preventa_corporativa_data?.plan!}-backup`,
          nombre: `BACKUP ${dataFactibilidad?.preventa_corporativa_data?.data_plan_personalizado?.nombre_personalizado || dataFactibilidad?.data_plan_personalizado?.nombre_personalizado || "PLAN DE PRUEBA"}`,
          precioUnitario: 0,
          cantidad: 1,
          total: 0,
          subtotal: 0,
          ivaValue: 0,
          ivaCode: "",
          categoria_fcorporativa: CategoriaFCorporativaEnum.VALORESPLAN,
        })
      }
      setValoresPlanesCorporativos(ValoresPlan)
    }


    //añadir validacion para servicios que vayan a manejar valores
    const ValoresServiciosAdicionales: MaterialTransferidoInventarioCorporativo[] = []
    if (dataFactibilidad?.preventa_corporativa_data?.seguridad_perimetral) {
      ValoresServiciosAdicionales.push({
        codigo: "SEGURIDAD_PERIMETRAL",
        nombre: "SEGURIDAD PERIMETRAL",
        precioUnitario: dataFactibilidad.preventa_corporativa_data?.costo_seguridad_perimetral,
        cantidad: 1,
        total: dataFactibilidad.preventa_corporativa_data?.costo_seguridad_perimetral,
        subtotal: dataFactibilidad.preventa_corporativa_data?.costo_seguridad_perimetral,
        ivaValue: 0,
        ivaCode: "",
        categoria_fcorporativa: CategoriaFCorporativaEnum.SERVICIOSADICIONALES,
      })
    }
    if (dataFactibilidad?.preventa_corporativa_data?.fibra_oscura) {
      ValoresServiciosAdicionales.push({
        codigo: "FIBRA_OSCURA",
        nombre: "FIBRA OSCURA",
        precioUnitario: dataFactibilidad?.preventa_corporativa_data?.costo_fibra_oscura,
        cantidad: 1,
        total: dataFactibilidad?.preventa_corporativa_data?.costo_fibra_oscura,
        series: [],
        contiene_serie: false,
        categoria_fcorporativa: CategoriaFCorporativaEnum.SERVICIOSADICIONALES,
        producto_data: null,
      })
    }
    if (dataFactibilidad?.preventa_corporativa_data?.wifi_gestionado) {
      ValoresServiciosAdicionales.push({
        codigo: "WIFI_GESTIONADO",
        nombre: "WIFI GESTIONADO",
        precioUnitario: dataFactibilidad.preventa_corporativa_data?.costo_wifi_gestionado,
        cantidad: 1,
        total: dataFactibilidad.preventa_corporativa_data?.costo_wifi_gestionado,
        subtotal: dataFactibilidad.preventa_corporativa_data?.costo_wifi_gestionado,
        ivaValue: 0,
        ivaCode: "",
        categoria_fcorporativa: CategoriaFCorporativaEnum.SERVICIOSADICIONALES,
      })
    }
    if (dataFactibilidad?.preventa_corporativa_data?.cableado_interno) {
      ValoresServiciosAdicionales.push({
        codigo: "CABLEADO_INTERNO",
        nombre: "CABLEADO INTERNO",
        precioUnitario: dataFactibilidad.preventa_corporativa_data?.costo_cableado_interno,
        cantidad: 1,
        total: dataFactibilidad.preventa_corporativa_data?.costo_cableado_interno,
        subtotal: dataFactibilidad.preventa_corporativa_data?.costo_cableado_interno,
        ivaValue: 0,
        ivaCode: "",
        categoria_fcorporativa: CategoriaFCorporativaEnum.SERVICIOSADICIONALES,
      })
    }

    if (dataFactibilidad?.preventa_corporativa_data && dataFactibilidad?.preventa_corporativa_data?.num_ips_publicas_facturadas && parseInt(dataFactibilidad?.preventa_corporativa_data?.num_ips_publicas_facturadas || "0") > 0) {
      ValoresServiciosAdicionales.push({
        nombre: `IPs Facturadas x${dataFactibilidad?.preventa_corporativa_data?.num_ips_publicas_facturadas}`,
        codigo: "IPSFACTURADAS",
        id: "IPS FACTURADAS",
        precioUnitario: dataFactibilidad?.preventa_corporativa_data?.costo_valor_ip_facturado || 20,
        cantidad: parseFloat(dataFactibilidad?.preventa_corporativa_data?.num_ips_publicas_facturadas!) || 0,
        total: parseFloat(dataFactibilidad?.preventa_corporativa_data?.num_ips_publicas_facturadas || "0") * (dataFactibilidad?.preventa_corporativa_data?.costo_valor_ip_facturado || 0) || 0,
        subtotal: parseFloat(dataFactibilidad?.preventa_corporativa_data?.num_ips_publicas_facturadas || "0") * (dataFactibilidad?.preventa_corporativa_data?.costo_valor_ip_facturado || 0) || 0,
        ivaValue: 0,
        ivaCode: "",
        series: [],
        categoria_fcorporativa: CategoriaFCorporativaEnum.SERVICIOSADICIONALES,
      })
    }

    if (!!dataFactibilidad?.preventa_corporativa_data?.plan_tvmax) {
      ValoresServiciosAdicionales.push({
        nombre: `${dataFactibilidad?.preventa_corporativa_data?.plan_tvmax.nombre_plan_tvmax} x${dataFactibilidad?.preventa_corporativa_data?.num_ips_publicas_facturadas} usuarios`,
        codigo: dataFactibilidad?.preventa_corporativa_data?.plan_tvmax.codigo_plan_tvmax,
        id: "PLANTVMAX",
        precioUnitario: dataFactibilidad?.preventa_corporativa_data?.plan_tvmax?.costo_plan_tvmax || 20,
        cantidad: dataFactibilidad?.preventa_corporativa_data?.plan_tvmax?.usuarios_plan_tvmax || 0,
        total: (dataFactibilidad?.preventa_corporativa_data?.plan_tvmax?.usuarios_plan_tvmax || 0) * (dataFactibilidad?.preventa_corporativa_data?.plan_tvmax?.costo_plan_tvmax || 0),
        series: [],
        contiene_serie: false,
        categoria_fcorporativa: CategoriaFCorporativaEnum.SERVICIOSADICIONALES,
        producto_data: null,
      })
    }



    if (dataFactibilidad?.preventa_corporativa_data?.equipos_adicionales &&
      dataFactibilidad?.preventa_corporativa_data?.equipos_adicionales?.length > 0
    ) {
      dataFactibilidad?.preventa_corporativa_data?.equipos_adicionales?.map((x) => {
        ValoresServiciosAdicionales.push({
          codigo: x.codigo,
          nombre: x.producto_data?.descripcion + " " + x.codigo,
          precioUnitario: parseFloat(x.producto_data?.precios?.[0]?.precio || "0"),
          cantidad: 1,
          total: parseFloat(x.producto_data?.precios?.[0]?.precio || "0"),
          subtotal: parseFloat(x.producto_data?.precios?.[0]?.precio || "0"),
          ivaValue: 0,
          ivaCode: "",
          producto_data: x.producto_data,
          categoria_fcorporativa: CategoriaFCorporativaEnum.SERVICIOSADICIONALES,
        })
      })
    }

    if (dataFactibilidad?.preventa_corporativa_data?.servicios_adicionales &&
      dataFactibilidad?.preventa_corporativa_data?.servicios_adicionales?.length > 0
    ) {
      dataFactibilidad?.preventa_corporativa_data?.servicios_adicionales?.map((x) => {
        ValoresServiciosAdicionales.push({
          codigo: x.codigo || x.id,
          nombre: x.nombre,
          precioUnitario: parseFloat(x.precioUnitario || "0"),
          cantidad: parseFloat(x.cantidad || "0"),
          total: parseFloat(((x.precioUnitario || 0) * (x.cantidad || 1)).toString()),
          subtotal: parseFloat(((x.precioUnitario || 0) * (x.cantidad || 1)).toString()),
          ivaValue: 0,
          ivaCode: "",
          producto_data: null,
          categoria_fcorporativa: CategoriaFCorporativaEnum.SERVICIOSADICIONALES,
        })
      })
    }

    setValoresServiciosAdicionalesCorporativos(ValoresServiciosAdicionales)



  }, [dataFactibilidad]);

  const handleObtenerStockActual = async () => {

    setIsloadingInventaribale(true)

    try {

      let detallesBase = dataFactibilidad?.detalles || []
      
      /// esta condicion solo ejecutara cuando el producto que no se carga 
      if (detallesBase.length === 0) {

        const productosBase =
          dataFactibilidad?.productos_costeados?.filter(
            item =>
              item.categoria_fcorporativa === 'MATERIALESEQUIPOS' ||
              item.categoria_fcorporativa === 'EQUIPOSADICIONALES'
          ) || []

        // Obtener códigos
        const codigos = productosBase.map(item => item.codigo).join(',')
        //consultamos el producto
        const responseProductos = await getProductos({codigos})
        // Construir detalles correctamente

        detallesBase =
          responseProductos?.data?.data?.map(producto => {

            const productoCosteado =
              productosBase.find(
                item => item.codigo === producto.codigo
              )
              
            return {

              id: producto.id_producto,
              codigo: producto.codigo,

              cantidad:
                productoCosteado?.cantidad || 1,

              categoria_fcorporativa:
                productoCosteado?.categoria_fcorporativa,

              contiene_serie:
                producto.contiene_serie || false,

              series: [],

              producto_data: {

                codigo: producto.codigo,

                descripcion:
                  producto.descripcion,

                categoria_producto:
                  producto.categoria_producto,

                subcategoria_producto:
                  producto.subcategoria_producto,

                precios:
                  producto.precios || [],

                stock_actual:
                  producto.stock_actual
              }
            }
          }) || []

        await updateFactibilidadCorporativa.mutateAsync({
          id_factibilidad_coorporativa: dataFactibilidad.id_factibilidad_coorporativa,
          detalles: detallesBase
        })
      }

      const dataInventariable = await getProductos({
        codigos: dataFactibilidad.detalles.map(item => item.codigo).join(',')
      })


      const stockMap = new Map(
        dataInventariable?.data?.data?.map(e => [e.codigo, e.stock_actual]) || []
      );


      const newData = dataFactibilidad.detalles.map(element => ({
        ...element,
        existe: +stockMap.get(element.codigo)! > element.cantidad,
        stock_actual: stockMap.get(element.codigo) ?? 'N/A'
      }));

      copyArray(newData, MaterialesKey.ingresoProductos)

    } catch (error) {

    } finally {
      setIsloadingInventaribale(false)
    }
  }

  return (
    <SingleTableBoxScene
      title="Solicitud Factibilidad Corporativo"
      visibleReport={false}
      enableBackBtn={true}
      backPageUrl={ROUTER_PATHS.inventario.solicitudFactibilidadCorporativoNav}
      enableAccionBtn={
        false
        // !(dataFactibilidad.estado_factibilidad === EstadoFactibilidadCorporativaENUM.EN_GESTION
        //   || dataFactibilidad.estado_factibilidad === EstadoFactibilidadCorporativaENUM.CANCELADO
        //   || dataFactibilidad.estado_factibilidad === EstadoFactibilidadCorporativaENUM.APROBADO
        // )
      }
      fnAccionBtn={() => {
        setModalCancelar(true)
        // setConfirmDialogIsOpen(true);
        // setConfirmDialog({
        //   isOpen: true,
        //   title: '¡Confirmar!',
        //   subtitle: `Estás a punto de rechazar una solicitud de factibilidad corporativa para materiales y equipos. ¿Estás seguro? Este cambio no se puede deshacer.`,
        //   confirmTextBtn: 'Confirmar',
        //   onClose() {
        //     setConfirmDialogIsOpen(false);
        //   },
        //   async onConfirm() {

        //     mutateAsyncPutFactibilidadCorporativo({
        //       id_factibilidad_coorporativa: dataFactibilidad.id_factibilidad_coorporativa,
        //       estado_factibilidad: EstadoFactibilidadCorporativaENUM.CANCELADO
        //     })

        //     setConfirmDialogIsOpen(false);

        //   },
        //   btnTitle: 'Cerrar',
        // });
      }}
      enableCreateOrEditBtn={
        !dataFactibilidad.preaprobado_inventario
        || (dataFactibilidad.preaprobado_inventario && !dataFactibilidad.aprobado_inventario && dataFactibilidad.aprobado_supervisor)
        || (dataFactibilidad.aprobado_inventario && dataFactibilidad.aprobado_supervisor
          && dataFactibilidad.estado_factibilidad !== EstadoFactibilidadCorporativaENUM.APROBADO)
      }
      fnCreateOrEdit={() => {

        const existe = ingresoProductos.every(e => e.existe)

        setConfirmDialogIsOpen(true);
        setConfirmDialog({
          isOpen: true,
          title: 'APROBAR',
          subtitle: existe
            ? `Estás a punto de aprobar una solicitud de factibilidad corporativa para materiales y equipos. ¿Estás seguro? Este cambio no se puede deshacer.`
            : `Se ha detectado que algunos productos no fuerón marcados o no tienen stock. ¿Estás seguro de continuar? Este cambio no se puede deshacer.`,
          confirmTextBtn: 'APROBAR',
          onClose() {
            setConfirmDialogIsOpen(false);
          },
          async onConfirm() {
            let nuevoArray = ingresoProductos.map(({ stock_actual, ...resto }) => resto);

            let auxProdCosteados: MaterialTransferidoInventarioCorporativo[] = []
            dataFactibilidad?.detalles?.forEach(element => {
              //const precioUnitarioAux = element?.producto_data?.precios[0]?.precio || 0;
              const precioUnitarioAux = (+element.producto_data?.precios?.at(0)?.precio) || element.precioUnitario || 0;


              auxProdCosteados.push(
                {
                  codigo: element?.codigo || element?.id,
                  nombre: element?.producto_data?.descripcion || element?.nombre,
                  precioUnitario: element?.precioUnitario || +precioUnitarioAux,
                  cantidad: element?.cantidad || 1,
                  total: element?.total || element.cantidad * +precioUnitarioAux,
                  subtotal: element?.subtotal || element.cantidad * +precioUnitarioAux,
                  ivaCode: element?.ivaCode || "IVA 0%",
                  ivaValue: element?.ivaValue || 0, // 15% de 50
                  incremento: element?.incremento,
                  incrementoCodigo: element.incrementoCodigo,
                  precioLibre: element.precioLibre || true,
                  preciosDisponibles: element.preciosDisponibles || element?.producto_data?.precios,
                  existe: element.existe,
                  // incremento:,
                  categoria_fcorporativa: element.categoria_fcorporativa || CategoriaFCorporativaEnum.MATERIALESEQUIPOS,
                }
              );
            });
            // =================================================================
            // Para procesar las que vienen por canje
            // =================================================================
            // if (aprobadoPage && 
            //   dataFactibilidad.prospecto_corporativo_data?.condicion_venta===CondicionVentaCorporativa.CANJE) {
            //   await mutateAsyncPutFactibilidadCorporativo({
            //     id_factibilidad_coorporativa: dataFactibilidad.id_factibilidad_coorporativa,
            //     estado_factibilidad: EstadoFactibilidadCorporativaENUM.APROBADO,
            //     aprobado_inventario: true,
            //     detalles: nuevoArray,

            //   })
            // }

            // =================================================================
            // Cuando ya esta en true preaprobado_inventario, 
            // aceptado_factibilidad, aprobado_supervisor
            // =================================================================
            if (aprobadoPage) {
              await mutateAsyncPutFactibilidadCorporativo({
                id_factibilidad_coorporativa: dataFactibilidad.id_factibilidad_coorporativa,
                estado_factibilidad: EstadoFactibilidadCorporativaENUM.APROBADO,
                aprobado_inventario: true,
                detalles: nuevoArray,
                factibilidad_enviada: true,
              })
            } else {
              await mutateAsyncPutFactibilidadCorporativo({
                id_factibilidad_coorporativa: dataFactibilidad.id_factibilidad_coorporativa,
                estado_factibilidad: EstadoFactibilidadCorporativaENUM.EN_GESTION,
                preaprobado_inventario: true,
                detalles: nuevoArray,
                productos_costeados: auxProdCosteados.concat(valoresServiciosAdicionalesCorporativos).concat(valoresPlanesCorporativos),
              })
            }

            setConfirmDialogIsOpen(false);

          },
          cancelTextBtn: 'Cerrar',
        });


      }}
      textCreateOrEditBtn={'Aprobar'}
      iconCreateOrEdit={<TaskAltIcon />}
    >
      <Grid container spacing={3} marginTop={1}>

        <CustomTextFieldNoForm
          disabled={true}
          label={`Fecha solicitud`}
          defaultValue={formatDateWithTimeAMPM(dataFactibilidad.fecha_creacion)}
          size={gridSizeMdLg4}
        />

        <CustomTextFieldNoForm
          disabled={true}
          label={`# Referencia`}
          defaultValue={dataFactibilidad.numero_referencia}
          size={gridSizeMdLg4}
        />

        <CustomTextFieldNoForm
          disabled={true}
          label={`Asesor`}
          defaultValue={dataFactibilidad.user_create_data?.razon_social || dataFactibilidad.user_create}
          size={gridSizeMdLg4}
        />

        {/* <CustomTextAreaNoForm
          label="Observación"
          value={dataFactibilidad.observaciones != null
            ? dataFactibilidad.observaciones.observacion_1 : 'N/A'}
          rows={2}
          defaultValue={dataFactibilidad.observaciones != null
            ? dataFactibilidad.observaciones.observacion_1 : 'N/A'}
        /> */}

        <Grid item xs={12} container justifyContent={'end'} >
          <Button
            onClick={() => {
              handleObtenerStockActual()
            }}
            endIcon={<Refresh />}
          >
            Actualizar
          </Button>
        </Grid>
        <Grid item xs={12} justifyContent={'center'} textAlign={'center'}>

          {!isloadingInventaribale ? (
            <SampleTable<MaterialTransferido>
              rowNumber={true}
              columns={columnsMaterialRevisarFactibilidadCorporativo}
              data={ingresoProductos}
            //enableRowSelection={row => +row.original.stock_actual! >= row.original.cantidad}
            />
          ) : <CircularProgress />

          }


        </Grid>

        {/* PRV-002: Sección Información Adicional (Solo Lectura) */}
        {(dataFactibilidad?.area_responsable_inspeccion || dataFactibilidad?.url_archivo_inspeccion_adicional) && (
          <Grid item xs={12} sx={{ mt: 3 }}>
            <Typography variant="h6" sx={{
              borderBottom: '2px solid #1976d2',
              paddingBottom: 1,
              marginBottom: 2
            }}>
              Información Adicional
            </Typography>
            <Grid container spacing={2}>
              {dataFactibilidad?.area_responsable_inspeccion && (
                <Grid item xs={12} md={6}>
                  <CustomTextFieldNoForm
                    label="Área Responsable"
                    value={dataFactibilidad.area_responsable_inspeccion}
                    disabled
                    shrink
                  />
                </Grid>
              )}
              {dataFactibilidad?.url_archivo_inspeccion_adicional && (
                <Grid item xs={12} md={6} sx={{ display: 'flex', alignItems: 'center' }}>
                  <a
                    target="_blank"
                    href={dataFactibilidad.url_archivo_inspeccion_adicional}
                    rel="noreferrer"
                    style={{ textDecoration: 'none' }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        color: 'primary.main',
                        textDecoration: 'underline',
                        cursor: 'pointer'
                      }}
                    >
                      Ver/Descargar Documento de Inspección
                    </Typography>
                  </a>
                </Grid>
              )}
              {dataFactibilidad.url_archivo_propuesta_tecnica && (
                <Grid item xs={12} md={6} sx={{ display: 'flex', alignItems: 'center' }}>
                  <a
                    target="_blank"
                    href={dataFactibilidad.url_archivo_propuesta_tecnica}
                    rel="noreferrer"
                    style={{ textDecoration: 'none' }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        color: 'primary.main',
                        textDecoration: 'underline',
                        cursor: 'pointer'
                      }}
                    >
                      Ver/Descargar Documento de Propuesta Técnica
                    </Typography>
                  </a>
                </Grid>

              )}
            </Grid>
          </Grid>
        )}
        {/* FIN PRV-002 */}

      </Grid>

      {modalCancelar && (
        <ScrollableDialogProps
          open={modalCancelar}
          title="¡Confirmar!"
          confirmVariantBtn="contained"
          dialogContentText={`Estás por rechazar una factibilidad corporativa. ¿Estás seguro este cambio es irreversible?`}
          contentNode={
            <Grid container spacing={3}>
              <CustomAutocomplete<MotivoRechazo>
                label="Motivo de rechazo"
                name="motivo_rechazo"
                // options
                options={motivosRechazoPaging?.data?.data || []}
                valueKey="nombre"
                actualValueKey="codigo"
                defaultValue={formRechazo.getValues().motivo_rechazo || ""}
                isLoadingData={
                  isLoadingMotivosRechazo || isRefetchingMotivosRechazo
                }
                // validation
                control={formRechazo.control}
                error={formRechazo?.formState?.errors.motivo_rechazo}
                helperText={
                  !!formRechazo?.formState?.errors.motivo_rechazo?.message &&
                  "El motivo de rechazo es requerido"
                }
                disableClearable
              />

              <CustomTextArea
                label="Observación"
                name="observacion_motivo_rechazo"
                maxRows={3}
                control={formRechazo.control}
                defaultValue={
                  formRechazo.getValues().observacion_motivo_rechazo ?? ""
                }
                error={formRechazo.formState.errors.observacion_motivo_rechazo}
                helperText={
                  formRechazo.formState.errors.observacion_motivo_rechazo
                    ?.message
                }
                required={false}
              />
            </Grid>
          }
          onConfirm={formRechazo.handleSubmit(async (_form) => {

            mutateAsyncPutFactibilidadCorporativo({
              id_factibilidad_coorporativa: dataFactibilidad.id_factibilidad_coorporativa,
              estado_factibilidad: EstadoFactibilidadCorporativaENUM.CANCELADO,
              observacion_rechazo: [
                {
                  motivo: formRechazo.getValues().observacion_motivo_rechazo,
                  observacion: formRechazo.getValues().motivo_rechazo,
                  fecha: (new Date()).toISOString()
                }
              ]
            })

            setModalCancelar(false);
          })}
          onClose={() => {
            setModalCancelar(false);
          }}
        />
      )}


    </SingleTableBoxScene>
  )

}